/* pm-product-tabs.js: <pm-product-tabs> for sections/home-product-tabs.liquid.
   Switches the visible tab panel on click and with ArrowLeft / ArrowRight / Home / End, keeps the Discover
   button(s) pointing at the active tab's collection (unless the section has a fixed link), and runs one Swiper per
   panel: initialised the first time a panel is shown (panel.dataset.swiper = 'ready'), updated on later shows.
   Swiper is a deferred CDN script: when window.Swiper is missing we wait for the window load event and retry once
   more a second later. Theme editor: shopify:block:select selects that tab, shopify:section:load re-inits. */
(function () {
  'use strict';

  if (customElements.get('pm-product-tabs')) return;

  var SWIPER_OPTIONS = {
    slidesPerView: 1.25,
    spaceBetween: 12,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
    watchOverflow: true,
    breakpoints: {
      750: { slidesPerView: 2.2, spaceBetween: 20, slidesOffsetBefore: 0, slidesOffsetAfter: 0 },
      990: { slidesPerView: 3, spaceBetween: 20, slidesOffsetBefore: 0, slidesOffsetAfter: 0 },
      1200: { slidesPerView: 4, spaceBetween: 20, slidesOffsetBefore: 0, slidesOffsetAfter: 0 }
    }
  };

  function whenSwiper(callback) {
    if (window.Swiper) {
      callback();
      return;
    }
    var done = false;
    var attempt = function () {
      if (done) return;
      if (!window.Swiper) return;
      done = true;
      callback();
    };
    var retryLater = function () {
      attempt();
      if (!done) setTimeout(attempt, 1000);
    };
    if (document.readyState === 'complete') {
      setTimeout(attempt, 1000);
      return;
    }
    window.addEventListener('load', retryLater, { once: true });
  }

  class PmProductTabs extends HTMLElement {
    connectedCallback() {
      this.init();
    }

    init() {
      if (this.ready) return;
      this.ready = true;
      var self = this;
      this.fixedLink = this.dataset.fixedLink === 'true';
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      this.panels = this.tabs.map(function (tab) {
        return self.querySelector('#' + CSS.escape(tab.getAttribute('aria-controls')));
      });
      this.ctas = Array.prototype.slice.call(this.querySelectorAll('[data-cta]'));
      this.tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          self.select(index);
        });
        tab.addEventListener('keydown', function (event) {
          self.onKeydown(event, index);
        });
      });
      var current = 0;
      this.tabs.forEach(function (tab, index) {
        if (tab.getAttribute('aria-selected') === 'true') current = index;
      });
      this.select(current, false);
    }

    select(index, focus) {
      var self = this;
      var tab = this.tabs[index];
      if (!tab) return;
      this.tabs.forEach(function (item, i) {
        var active = i === index;
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
        var panel = self.panels[i];
        if (panel) panel.hidden = !active;
      });
      if (!this.fixedLink && tab.dataset.url) {
        this.ctas.forEach(function (cta) {
          cta.setAttribute('href', tab.dataset.url);
        });
      }
      if (focus) tab.focus();
      this.mount(this.panels[index]);
    }

    mount(panel) {
      if (!panel) return;
      var slider = panel.querySelector('.pm-ptabs__slider');
      if (!slider) return;
      whenSwiper(function () {
        if (panel.hidden) return;
        if (panel.dataset.swiper === 'ready') {
          if (slider.swiper) slider.swiper.update();
          return;
        }
        panel.dataset.swiper = 'ready';
        var options = Object.assign({}, SWIPER_OPTIONS, {
          navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev')
          }
        });
        new window.Swiper(slider, options);
      });
    }

    onKeydown(event, index) {
      var last = this.tabs.length - 1;
      var next;
      switch (event.key) {
        case 'ArrowRight':
          next = index === last ? 0 : index + 1;
          break;
        case 'ArrowLeft':
          next = index === 0 ? last : index - 1;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = last;
          break;
        default:
          return;
      }
      event.preventDefault();
      this.select(next, true);
    }
  }

  customElements.define('pm-product-tabs', PmProductTabs);

  // Block ids are only unique within a section, so look inside the selected section.
  document.addEventListener('shopify:block:select', function (event) {
    var section = document.getElementById('shopify-section-' + event.detail.sectionId);
    var tab = section && section.querySelector('[role="tab"][data-block-id="' + event.detail.blockId + '"]');
    var tabs = tab && tab.closest('pm-product-tabs');
    if (tabs && tabs.tabs) tabs.select(tabs.tabs.indexOf(tab));
  });

  document.addEventListener('shopify:section:load', function (event) {
    var elements = event.target.querySelectorAll('pm-product-tabs');
    Array.prototype.forEach.call(elements, function (element) {
      if (typeof element.init === 'function') element.init();
    });
  });
})();
